/**
 * "Remember this clinic and skip this screen next time".
 *
 * A pure UI preference: it decides whether the clinic picker is shown, not what
 * the user is allowed to open. Every request still carries X-Active-Clinic and
 * the backend still re-validates it against org membership, so a tampered value
 * here gets a 403 rather than another clinic's data.
 *
 * Stored per browser rather than per account — it answers "on this device, do
 * I usually work in one branch?", which is a property of the device. The
 * receptionist's desk in Pitampura wants Pitampura every time; the owner's
 * laptop probably wants to be asked.
 */

const STORAGE_KEY = "kaagazy_remembered_clinic_id";

/** The clinic to skip the picker for, or null to always ask. */
export function getRememberedClinicId(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    // Blocked storage — fall back to asking, which is the safe direction:
    // showing the picker unnecessarily costs a click, skipping it wrongly
    // drops someone into a clinic they did not choose.
    return null;
  }
}

/** Pass a clinic id to skip the picker next time, or null to clear. */
export function setRememberClinic(clinicId: string | null): void {
  try {
    if (clinicId) localStorage.setItem(STORAGE_KEY, clinicId);
    else localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* non-fatal — the picker simply keeps appearing */
  }
}
